module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Im0xMy40MSAxMmw0LjMtNC4yOWExIDEgMCAxIDAtMS40Mi0xLjQyTDEyIDEwLjU5bC00LjI5LTQuM2ExIDEgMCAwIDAtMS40MiAxLjQybDQuMyA0LjI5bC00LjMgNC4yOWExIDEgMCAwIDAgMCAxLjQyYTEgMSAwIDAgMCAxLjQyIDBsNC4yOS00LjNsNC4yOSA0LjNhMSAxIDAgMCAwIDEuNDIgMGExIDEgMCAwIDAgMC0xLjQyWiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-close1.svg
// module id = y2zy
// module chunks = 1